import {
    instance as axios,
    setJwtToken,
  } from "../../config/axiosInstance";
  
export const teethTrackingListApi = async (data) => {
  const endPoint = `admin/teeth-tracking/list?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};
